import { computed } from 'vue'
import { useStore } from 'vuex'

export function useCurrentUser() {
  const store = useStore()
  const currentUser = computed(() => {
    return store.getters['session/currentUser']
  })

  const isImpersonatingOtherUser = computed(() => {
    return !!currentUser.value?.impersonatedUserId
  })

  const impersonatedUserNick = computed(() => {
    return currentUser.value?.impersonatedUserLabel
  })

  const currentUserAvatarImageUrl = computed(() => {
    return null
  })

  const currentUserInitials = computed(() => {
    if (currentUser.value?.name && currentUser.value?.surname) {
      return `${currentUser.value.name[0]}${currentUser.value.surname[0]}`
    }
    return currentUser.value?.email?.substring(0, 2)?.toUpperCase() || null
  })

  const currentUserNick = computed(() => {
    if (currentUser.value?.name && currentUser.value?.surname) {
      return `${currentUser.value.name} ${currentUser.value.surname}`
    }
    return currentUser.value?.email?.substring(0, 2)?.toUpperCase() || '??'
  })

  const currentUserMail = computed(() => {
    return currentUser.value?.email
  })

  return {
    currentUser,
    currentUserAvatarImageUrl,
    currentUserInitials,
    currentUserNick,
    currentUserMail,
    isImpersonatingOtherUser,
    impersonatedUserNick,
  }
}
